<template>
    <div class="wrapper-card">
        <div v-if="width > 1000" class="sidenav-wrapper">
            <SideNav />
        </div>
        <div class="content-wrapper">
            <EventManageHeader
                :counterOfferData.sync="counterOfferData"
                :eventId="eventId"
                :eventDate.sync="eventDate"
            />
            <div class="bottom-line-up"></div>
            <p class="wrap-up-title">Time to Wrap Up</p>
            <div v-if="eventId && counterOfferData">
                <PayoutSummary
                    :artists.sync="artists"
                    :counterOfferData="counterOfferData"
                    :eventId="eventId"
                    :eventDate.sync="eventDate"
                />
                <ArtistFeedbackCard
                    v-for="(artist, index) in getArtistsFeedbacks"
                    :key="index"
                    :artist="artist"
                    :eventId="eventId"
                    :counterOfferData="counterOfferData"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import PayoutSummary from './wrap-up-booking/PayoutSummary.vue'
    import ArtistFeedbackCard from './wrap-up-booking/ArtistFeedbackCard.vue'
    import EventManageHeader from './EventManageHeader.vue'
    import SideNav from '../../parts/SideNav.vue'
    import checkScreen from '../../../mixins/check-screen'
    import axios from 'axios'
    export default {
        name: 'EventWrapUpPage',
        mixins: [checkScreen],
        props: {
            artists: {
                type: Array
            },
            counterOfferData: {
                type: Object
            }
        },
        components: {
            EventManageHeader,
            PayoutSummary,
            ArtistFeedbackCard,
            SideNav
        },
        data: () => ({
            eventId: null,
            eventDate: null,
            allArtists: [],
            artistsFeedback: [],
            editFeedback: false,
            bookingId: null
        }),
        methods: {
            async getArtistsReview() {
                const response = await axios.get('/api/get/artist/' + this.eventId)
                this.artistsFeedback = response.data.data
            },
            async getArtistsFeedback() {
                const response = await axios.get('/api/get/artists-to-review/' + this.eventId)
                this.allArtists = response.data.data
            }
        },
        computed: {
            getArtistsFeedbacks() {
                if (this.artistsFeedback.length) {
                    const artistsToReview = this.allArtists.filter((artist) => {
                        return !this.artistsFeedback.some(
                            (feedback) => feedback.artist_id === artist.artist_id
                        )
                    })
                    return [...this.artistsFeedback, ...artistsToReview]
                }
                return this.allArtists
            }
        },
        async created() {
            this.eventId = localStorage.getItem('eventId')
            this.bookingId = localStorage.getItem('bookingId')
            await this.getArtistsReview()
            await this.getArtistsFeedback()

            this.$root.$on('payment-added', async () => {
                await this.getArtistsReview()
                await this.getArtistsFeedback()
            })
        },
        mounted() {
            this.eventDate = localStorage.getItem('eventDate')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .content-wrapper {
        flex: 0 1 90%;
    }
    .bottom-line-up {
        display: flex;
        flex-direction: row;
        border: 1px solid #646464;
        width: 100%;
        margin-top: 25px;
    }
    .wrapper-card {
        max-width: 100%;
        overflow: hidden;
    }
    .wrapper-card {
        display: flex;
        background: #000;
        align-items: flex-start;
        padding: 50px;
        gap: 58px;
    }
    .wrap-up-title {
        color: #d188bf;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
        margin-bottom: 25px;
        margin-top: 60px;
    }
    @media (max-width: 600px) {
        .wrapper-card {
            padding: 0;
        }
        .wrap-up-title {
            padding: 0 16px;
            font-size: 38px;
        }
        .content-wrapper {
            width: 100%;
        }
    }
</style>
